import { render, staticRenderFns } from "./acessControlUpdate.vue?vue&type=template&id=6c074f38&scoped=true"
import script from "./acessControlUpdate.vue?vue&type=script&lang=js"
export * from "./acessControlUpdate.vue?vue&type=script&lang=js"
import style0 from "./acessControlUpdate.vue?vue&type=style&index=0&id=6c074f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c074f38",
  null
  
)

export default component.exports